// src/components/common/LangLink.jsx
import { Link } from 'react-router-dom';
import { useLanguageLink } from '../../hooks/useLanguageLink';

export const LangLink = ({ to, ...props }) => {
  const { langLink } = useLanguageLink();
  return <Link to={langLink(to)} {...props} />;
};
